import "./ServiceStructure.css"

const TitlePanel = props => {
  return (
    <div className="page-two-content">
      <div className="row d-md-flex justify-content-between align-items-center">
        <div className="col-md-9 text-white">
          <span className="span-title-three">{props.serviceType}</span>
          <div className="span-dub-two mb-3">
            <span></span>
          </div>
          <p className="department">
            <strong>{props.department}</strong>
          </p>
        </div>
        <div className="col-md-3">
          <a
            href={props.url}
            className="btn btn-success btn-block btn-lg float-md-right mt-5 mt-md-0 col-12"
            style={{ fontSize: 24 }}
          >
            Apply Now{" "}
          </a>
        </div>
      </div>
    </div>
  )
}

export default TitlePanel
